import { Directive, ElementRef, inject } from '@angular/core';
import { InAppBrowserService } from 'src/app/@core/in-app-browser.service';
import { Platform } from '@ionic/angular';

@Directive({
  selector: '[handle-external-links]',
  standalone: false,
})
export class HandleExternalLinksDirective {
  private element = inject(ElementRef);
  private inAppBrowserService = inject(InAppBrowserService);
  private platform = inject(Platform);

  public ngOnInit(): void {
    this.element.nativeElement.addEventListener('click', this.onElementClicked.bind(this));
  }

  private onElementClicked(ev: Event): void {
    const elem = ev.target as HTMLElement;

    if (!elem) { return; }
    if (elem.tagName.toUpperCase() !== 'A') { return; }

    ev.preventDefault();
    ev.stopPropagation();

    const url = elem.getAttribute('href');

    if (!url) { return; }

    if (url.includes('tel:') || url.includes('mailto:')) {
      if (this.platform.is('android')) {
        window.open(url, '_system');

        return;
      }

      window.location.href = url;

      return;
    }

    this.inAppBrowserService.openUrl(url);
  }
}
